var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ErrorMessage, Field } from 'formik';
var IssueZoneSelect = function (_a) {
    var values = _a.values, errors = _a.errors, touched = _a.touched, isSubmitting = _a.isSubmitting, _b = _a.categories, categories = _b === void 0 ? {} : _b, setFieldValue = _a.setFieldValue, actions = _a.actions, telescript = _a.telescript;
    var categoryKeys = Object.keys(categories);
    return (_jsxs(_Fragment, { children: [_jsxs(Field, { disabled: isSubmitting, as: 'select', className: 'form-control theme-select text-and-select' + (errors.issue_zone && touched.issue_zone ? ' is-invalid' : ''), name: 'issue_zone', id: 'issue_zone', value: values.issue_zone, onChange: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                    var value;
                    return __generator(this, function (_a) {
                        actions.feedbackActions.reset();
                        value = e.target.value;
                        setFieldValue('issue_zone', value);
                        setFieldValue('issue_category', '');
                        setFieldValue('issue_categories', categories[value]);
                        return [2 /*return*/];
                    });
                }); }, children: [_jsx("option", { value: '', disabled: true, children: (telescript === null || telescript === void 0 ? void 0 : telescript.categoryOfIssueLabel) || 'Please select' }, 'issue_zone_placeholder'), categoryKeys.map(function (zoneName, index) { return (_jsx("option", { value: zoneName, children: zoneName }, "zone-".concat(index))); })] }), _jsx(ErrorMessage, { name: 'issue_zone', component: 'div', className: 'invalid-input text-danger' })] }));
};
export default IssueZoneSelect;
